export const LogoImage = ({ className = "h-16" }) => (
  <img
    src="/logo.png"
    alt="RIDGELINE DIGI PARTNER — Digital Solutions | Real Growth"
    className={`${className} w-auto rounded-xl bg-white p-1.5 object-contain shadow-[0_4px_20px_rgba(37,99,235,0.35)] ring-1 ring-white/20`}
  />
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center" data-testid="nav-brand-logo">
    <LogoImage className={compact ? "h-12" : "h-16"} />
  </span>
);
